import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'El Protocolo Paso a Paso',
    desc: 'Qué hacer exactamente del Día 1 al Día 7.'
  }, {
    title: 'Guiones Palabra por Palabra',
    desc: 'Qué decir para validar su dolor sin causar rechazo.'
  }, {
    title: 'La Técnica del Espejo',
    desc: 'Cómo escuchar para que él sienta que realmente lo entiendes.'
  }, {
    title: 'Checklists Diarios',
    desc: 'Para asegurarte de que vas por el camino correcto.'
  }, {
    title: 'Guía de Crisis',
    desc: 'Qué hacer ante una explosión de ira o un momento de riesgo.'
  }];
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold mb-12 text-center" data-id="element-105">
            Lo que obtienes hoy
          </h2>

          <div className="space-y-4" data-id="element-106">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start p-6 bg-white rounded-xl shadow-sm border border-amber/10" data-id="element-107">
                <CheckCircleIcon className="w-8 h-8 text-success flex-shrink-0 mr-4 mt-0.5" data-id="element-108" />
                <div data-id="element-109">
                  <h3 className="font-heading font-bold text-xl text-navy mb-1" data-id="element-110">
                    {item.title}
                  </h3>
                  <p className="font-body text-charcoal text-lg" data-id="element-111">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}